import React from 'react';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import { useState } from 'react';
import { useEffect } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  getSingleCarTowing,
  saveAItem,
  removeSavedItem,
  getSavedItems,
} from '../../../../Redux/Actions/UserAction';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { buildSavedIdSet, findSavedItemId } from '../../../../utils/savedItems';
import { CommonBanner } from '../CommonBanner';
import { useTranslation } from 'react-i18next';

const defaultImages = [
  {
    original: 'assets/images/user/car-dealers/a.jpg',
    thumbnail: 'assets/images/user/car-dealers/a.jpg',
    originalHeight: '300',
    originalWidth: '400',
    sizes: '200',
  },
];

export default function UserTowingDetails() {
  const { t, i18n } = useTranslation();
  /* [CF 2026-08-17] The brand shown here came from `carDetails.name`, which is
     the English spelling, so an Arabic visitor read BMW / AUDI / LAND ROVER. The
     API now returns `nameAr` beside it (taxiOwner + towingOwner services), so
     pick whichever matches the language. */
  const isRTLBrand = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const brandName = (cd) =>
    (isRTLBrand ? cd?.nameAr || cd?.name : cd?.name || cd?.nameAr) || '';

  const [images, setImages] = useState([]);
  const { towingOwnerId } = useParams();
  const dispatch = useDispatch();
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [savedOverride, setSavedOverride] = useState(null);

  useEffect(() => {
    dispatch(getSingleCarTowing(towingOwnerId));
    dispatch(getSavedItems());
  }, [dispatch, towingOwnerId]);

  const home = useSelector((state) => state?.home);
  const data = home?.singleCarTowing?.[0];
  const savedItemsList = home?.savedItemsList;
  const saved =
    savedOverride !== null
      ? savedOverride
      : buildSavedIdSet(savedItemsList).has(String(data?.towingOwnerId));

  useEffect(() => {
    const value = [];
    data?.businessMedia?.forEach((element) => {
      if (element?.mediaType === 'IMAGES') {
        value.push({
          original: element?.media?.path,
          thumbnail: element?.media?.path,
          originalHeight: '300',
          originalWidth: '400',
          sizes: '200',
        });
      }
    });

    if (value.length === 0) {
      // Use fallback if no images found
      setImages(defaultImages);
    } else {
      setImages(value);
    }
  }, [data]);

  if (!data) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  console.log('singleCarTowing', images);

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Location Data
  const gpsData =
    typeof data?.gps === 'string' ? JSON.parse(data?.gps) : data?.gps;
  const lat = parseFloat(gpsData?.lat);
  const lng = parseFloat(gpsData?.long);

  const handleShare = async (e) => {
    e.preventDefault();

    const shareData = {
      title: document.title,
      text: 'Check this out!',
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
      }
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  const onHandleSave = (e) => {
    e.preventDefault();

    const isLoggedIn = sessionStorage.getItem('loged_In') === 'true';

    if (!isLoggedIn) {
      window.location.href = '#/login';
      return;
    }

    const id = data?.towingOwnerId;
    if (saved) {
      setSavedOverride(false);
      const savedItemId = findSavedItemId(savedItemsList, id);
      if (savedItemId) dispatch(removeSavedItem({ savedItemId }));
    } else {
      setSavedOverride(true);
      dispatch(saveAItem({ towingOwnerId: id }));
    }
  };

  return (
    // [CF 2026-08-09 #12b] Towing was the last profile still using the
    // two-column car-detail layout, so its banner sat in a padded, rounded box
    // inside `col-lg-7` while every other category shows a full-bleed hero
    // band. Restructured the same way the taxi page was: the banner becomes an
    // edge-to-edge `.user-banner` hero ABOVE the content, and the details drop
    // into a single centred column below it.
    <div className="user-towing-detail-wrap">
      <div className="user-banner user-towing-banner">
        <CommonBanner bannerImages={images} />
      </div>
      <div className="main-content-area">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 col-md-10 col-lg-8 mx-auto d-flex align-items-start">
              <div
                className="sidebar-box w-100"
                style={{ position: 'sticky', top: '16px', alignSelf: 'flex-start' }}
              >
                {/* [CF] Name + Save + Share on ONE line; availability below */}
                <div className="mb-3">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '16px',
                    }}
                  >
                    <h3 className="mb-0">
                      {data?.user?.firstName} {data?.user?.lastName}
                    </h3>
                    <div
                      className="save-share"
                      style={{ display: 'flex', alignItems: 'center', gap: '18px', flexShrink: 0 }}
                    >
                      <span onClick={onHandleSave} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                        <i className={saved ? 'fas fa-heart' : 'far fa-heart'} style={{ color: saved ? '#FFC400' : 'inherit' }}></i> {t('Save')}
                      </span>
                      <span onClick={handleShare} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                        <i className="far fa-share-square"></i> {t('Share')}
                      </span>
                    </div>
                  </div>
                  <p
                    className="mb-0"
                    style={{
                      fontWeight: 600,
                      color: data?.invisible ? '#dc3545' : '#28a745',
                    }}
                  >
                    {data?.invisible ? t('Not Available') : t('Available')}
                  </p>
                </div>

                {/* [CF-12] Location text removed — it's already shown by the
                    Location button/icon below, so this was duplicated. */}

                {/* [CF-8] Vehicle Details now uses the same horizontal stat
                    strip as the Car Dealer module (.car-details-block). */}
                <div className="car-details-block">
                  <div className="row">
                    <div className="col-6">
                      <div className="line-a">{t('Car Type')}</div>
                      <div className="line-b">
                        {brandName(data?.carDetails) || 'N/A'}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="line-a">{t('Plate Number')}</div>
                      <div className="line-b">#{data?.plateNumber}</div>
                    </div>
                  </div>
                </div>

                <div className="car-agent-cwm" style={{ marginTop: '20px' }}>
                  <div className="row">
                    <div className="col-4">
                      <CallLink
                        className="btn btn-outline-secondary btn-block"
                        record={data}
                        style={{ padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/telephone.svg"
                          alt="Call"
                          className="icon-cwm"
                          style={{ width: '20px', height: '20px' }}
                        />
                        <span>{t('Call')}</span>
                      </CallLink>
                    </div>

                    <div className="col-4">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-outline-secondary btn-block"
                        href={`https://wa.me/${`${data?.whatsAppNumberCountryCode}${data?.whatsAppNumber}`.replace(/\D/g, '')}`}
                        style={{ padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/whatsapp.svg"
                          alt="WhatsApp"
                          className="icon-cwm"
                          style={{ width: '20px', height: '20px' }}
                        />
                        <span>{t('WhatsApp')}</span>
                      </a>
                    </div>

                    <div className="col-4">
                      <a
                        className="btn btn-outline-secondary btn-block"
                        href="javascript:void(0);"
                        role="button"
                        onClick={handleOpenMap}
                        style={{ padding: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/map.svg"
                          alt="Location"
                          className="icon-cwm"
                          style={{ width: '20px', height: '20px' }}
                        />
                        <span>{t('Location')}</span>
                      </a>
                      <MapModalForView
                        open={mapModalOpen}
                        handleClose={handleCloseMap}
                        currentLocation={{
                          lat: lat,
                          long: lng,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
